import { caughtErrorLogFields, isAbortError, isClientLoggedError } from "@pandas/http-client";
import logger from "./logger";

// A failure the client logged above info keeps only info context here; anything
// else, an abort excepted, keeps this helper's error line.
export function logError(error: unknown, message?: string, ...optionalParams: unknown[]) {
	if (isAbortError(error)) return;
	const text = message ?? "Unexpected error occurred";
	if (isClientLoggedError(error)) {
		logger.info("FLOW", text, caughtErrorLogFields(error), optionalParams);
		return;
	}
	logger.error("FLOW", text, caughtErrorLogFields(error), optionalParams);
}
